export default __webpack_public_path__ + "static/media/FrieslandCampina_logo.6607e26b.svg";